import React, { useEffect, useState } from "react";
import pikug from "../../assets/images/claim/pikug.svg";
import useTranslation from "../../Languages/Translation";
import { useWeb3ModalProvider } from "@web3modal/ethers/react";
import { ethers } from "ethers";
import { getVePikuGAmount } from "../../Service/Web3/Web3Service";

const Delegation = () => {
  const [vePikuBalance, setVePikuBalance] = useState(0);
  const translation = useTranslation();
  const { walletProvider } = useWeb3ModalProvider()
  useEffect(() => {
    const provider = new ethers.BrowserProvider(walletProvider)
    const fetchData = async () => {
      const singer = await provider.getSigner();
      const vePiku = await getVePikuGAmount(singer);
      setVePikuBalance(parseFloat(vePiku).toFixed(2));
    }
    fetchData();
  }, [])
  const balancedlist = [
    {
      image: pikug,
      asset: "vePikuG",
      amount: vePikuBalance,
    },
    {
      image: pikug,
      asset: "vePikuG Delegated",
      amount: "-",
    },
    {
      image: pikug,
      asset: "vePikuG Delegated Percentage",
      amount: "-",
    },
  ];

  const delegation = [
    {
      asset: "Economist 1",
      button: "Delegate vePikuG",
    },
    {
      asset: "Economist 2",
      button: "Delegate vePikuG",
    },
    {
      asset: "Economist 3",
      button: "Delegate vePikuG",
    },
    {
      asset: "Economist 4",
      button: "Delegate vePikuG",
    },
  ];

  return (
    <div className=" main_container  pt-[120px]">
      <div className="max-w-[520px] mx-auto ">
        <div className="p-[32px] bg-[#222222] rounded-[24px]">
          <p className="text-[24px] text-white aeonik_medium leading-[30px]">
            {translation.Balances}
          </p>
          <div className="pt-[12px]">
            {balancedlist?.map((item, i) => (
              <div
                className="flex items-center justify-between mt-[12px]"
                key={i}
              >
                <div className="flex items-center">
                  <img
                    src={item.image}
                    alt="logo"
                    className="h-[32px] w-auto object-contain mr-[8px]"
                  />
                  <p className="text-[18px] text-white aeonik_normal leading-[23px]">
                    {item.asset}
                  </p>
                </div>
                <p className="text-[18px] text-white aeonik_normal leading-[23px]">
                  {item.amount}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="p-[24px] lg:p-[32px] bg-[#222222] rounded-[24px] mt-[16px] lg:mt-[24px]">
          <p className="text-[20px] lg:text-[24px] text-white aeonik_medium leading-[30px]">
            {translation.Delegation}
          </p>
          <table className="w-full mt-[24px]">
            <thead>
              <tr className="bg-[#383A3D]">
                <td className="text-[#9b9c9d] text-[14px] leading-[18px] text-left aeonik_medium py-[6px] rounded-l-[8px] pl-[12px]">
                  {translation.Delegates}
                </td>
                <td className="text-[#9b9c9d] text-[14px] leading-[18px] aeonik_medium py-[6px] rounded-r-[8px] text-left ">
                  {translation.TotalvePikuGDelegated}
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="pb-[16px]"></td>
              </tr>
              {delegation?.map((items, i) => (
                <tr key={i}>
                  <td className="text-white lg:text-[18px] leading-[23px] text-left aeonik_medium py-[6px] rounded-l-[8px] pl-[12px]">
                    {items.asset}
                  </td>
                  <td className="flex justify-between items-center py-[12px]">
                    <p className="text-white text-[20px] aeonik_normal leading-[25px]">
                      -
                    </p>
                    <a className="bg-[#223233] rounded-[6px] px-[16px] py-[6px] ">
                      <span className="text-[14px] lg:text-[16px] text-sky aeonik_medium leading-[24px]">
                        {items.button}
                      </span>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Delegation;
